export const ENTITY_LEVEL = {
  ORGANIZATION: 'organization',
  ACCOUNT: 'account',
  CONTACT: 'contact',
  TICKET: 'ticket',
  ALL: 'all',
};

export const SIDE_NAV_BAR_OPTIONS = {
  TICKET_DEDUPLICATION: 'ticketDeduplication',
  ENTITY_DEDUPLICATION: 'entityDeduplication',
  STATUS_MAPPING: 'statusMapping',
  PRIORITY_MAPPING: 'priorityMapping',
  IN: 'into',
  OUT: 'out',
};

export const TICKET_SIDE_NAV_BAR_OPTIONS = [
  {
    name: 'Unique ID & Deduplication',
    id: SIDE_NAV_BAR_OPTIONS.TICKET_DEDUPLICATION,
  },
  {
    name: 'Status Mapping',
    id: SIDE_NAV_BAR_OPTIONS.STATUS_MAPPING,
  },
  {
    name: 'Priority Mapping',
    id: SIDE_NAV_BAR_OPTIONS.PRIORITY_MAPPING,
  },
];
export const ENTITY_SIDE_NAV_BAR_OPTIONS = [
  {
    name: 'Unique ID & Deduplication',
    id: SIDE_NAV_BAR_OPTIONS.ENTITY_DEDUPLICATION,
  },
];
export const INTERCOM_DATA_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
};

export const REPORTER_SWITCH_TEXT = {
  [ENTITY_LEVEL.ORGANIZATION]:
    'Use Velaris Contact’s linked Entities to link Tickets to Entities',
  [ENTITY_LEVEL.ACCOUNT]:
    'Use Velaris Contact’s linked Entities to link Tickets to Entities',
  [ENTITY_LEVEL.CONTACT]:
    'When contacts are syncing, also create a Contact for Ticket Reporting if the reporter is not in Velaris as a Contact already',
};

export const INTERCOM_SUCCESS_MESSAGE =
  'Intercom configuration successfully saved';
